import { SelectOption } from '../SelectOption';

export const InfractionRuleDateColumns: Array<SelectOption> = [
  { value: 'LineItemDate', text: 'Line Item Date' },
  // { value: 'DateEntered', text: 'Current Date' },
  // { value: 'BillingEndDate', text: 'Billing End Date' },
  // { value: 'BillingStartDate', text: 'Billing Start Date' },
  { value: 'InvoiceDate', text: 'Invoice Date' },
  { value: 'DateCreated', text: 'Date Created' },
];

export const InfractionRuleTextColumns: Array<SelectOption> = [
  { value: 'LineItemDescription', text: 'Line Item Description' },
  //{ value: 'InvoiceDescription', text: 'Invoice Description' },
  { value: 'ClientMatterId', text: 'Client Matter Number' },
  { value: 'CountryCode', text: 'Country Code' },  
  { value: 'InvoiceNumber', text: 'Invoice Number' },  
  { value: 'LawFirmId', text: 'Law Firm' },
  { value: 'LawFirmMatterId', text: 'Law Firm Matter Number' },
  { value: 'LineItemActivityCode', text: 'Line Item Activity Code' },   
  { value: 'LineItemExpenseCode', text: 'Line Item Expense Code' },
  { value: 'LineItemNumber', text: 'Line Item Number' },  
  { value: 'LineItemTaskCode', text: 'Line Item Task Code' },  
  //{ value: 'LineItemType', text: 'Line Item Type' },
  { value: 'TimekeeperClassification', text: 'Timekeeper Classification' },  
  { value: 'TimekeeperName', text: 'Timekeeper Name' }
];